import React from "react";
import AboutMe from "./components/AboutMe";
import LeadershipPhilosophy from "./components/LeadershipPhilosophy";

export default function About() {
  return (
    <>
      <AboutMe />
      <LeadershipPhilosophy />
    </>
  );
}
